const Data = [
    {
        name: "Saurabh Zanwar",
        position: "UG Coordinator",
        imageUrl: "/assets/images/members/Heads21/Saurabh Zanwar.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Gopi Sravani",
        position: "UG Coordinator",
        imageUrl: "/images/profile.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Avyaya Bejawada",
        position: "UG Coordinator",
        imageUrl: "/assets/images/members/Heads21/Avyaya Bejawada.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    }
]

export default Data;